import "./Level13.scss";

export default function Level13() {
  return (
    <div className="level13__container">
      <div className="level13__puzzle">
        <div className="level13__div-columns-headers">
          <span className="level13__column-header">3</span>
          <span className="level13__column-header">2</span>
          <span className="level13__column-header">4</span>
          <span className="level13__column-header">1</span>
        </div>
        <div className="level13__div-rows">
          <div className="level13__row">
            <span className="level13__row-text">I</span>
            <span className="level13__row-text">R</span>
            <span className="level13__row-text">P</span>
            <span className="level13__row-text">C</span>
          </div>

          <div className="level13__row">
            <span className="level13__row-text">G</span>
            <span className="level13__row-text">O</span>
            <span className="level13__row-text">R</span>
            <span className="level13__row-text">T</span>
          </div>

          <div className="level13__row">
            <span className="level13__row-text">I</span>
            <span className="level13__row-text">F</span>
            <span className="level13__row-text">A</span>
            <span className="level13__row-text">A</span>
          </div>
        </div>
      </div>
    </div>
  );
}
